"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  gap: theme.spacing(3),
  maxWidth: '100%',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    maxWidth: '330px'
  },
  '&:empty': {
    display: 'none'
  }
}));
